// extracted by mini-css-extract-plugin
export var dotInactive = "Dots-module--dotInactive--3Cj__";
export var dotActive = "Dots-module--dotActive--2JyLj";
export var stripContainer = "Dots-module--stripContainer--qsGpa";